// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2wgVI"};